<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="rc_emname,rc_department"
      placeholder="输入申请人、部门进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/repairclass/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.rc_code}}</p>
          <p class="list-item-muted">{{item.rc_department}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.rc_emname}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.rc_status!='已审核'}"
          >{{item.rc_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}次</label>
    </div>
    <add-button to="/oa/repairclass_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/hr/repairClass/list",
      filters: [
        {
          type: "date",
          name: "createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "rc_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "rc_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>